import Form from "../forms/form";
import React from "react";
import MyCountdown from "../parts/countdown";
import BgVideo from "../../media/bws.mp4";
import BgVideoWebm from "../../media/bws.webm";
import Poster from "../../img/img_video.jpg";
import {MdPlace} from "react-icons/md";
import {IoCalendar} from "react-icons/io5";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";

function FirstScreenSlider({fsData}) {

    return (
        fsData ?
            <section className="bg-[#E7E9EC] mb-20 z-30 relative pt-[100px]" id="top">
                <div className="container mx-auto rounded-2xl overflow-hidden relative">
                    <div className="space-y-8 lg:space-y-10 relative z-20 px-4 pt-6 lg:pt-4 lg:px-7 sm:px-7">
                        <h1 className="copy-h1 leading-[90%] text-5xl sm:text-[4rem] xl:text-[4rem] 2xl:text-[5em] font-bold text-[#E7E9EC] uppercase">{fsData.fs_event_name}</h1>
                    </div>
                    <div className="grid w-full grid-cols-1 lg:grid-cols-[55%,45%] items-end justify-end relative z-40 lg:-mt-9">
                        <div className="md:justify-self-center lg:justify-self-start px-4 sm:px-6 lg:px-9 pb-9 pt-4 lg:pt-9">

                            <p className="mb-4 text-2xl sm:text-3xl uppercase bg-[#E7E9EC] ml-[-1.5rem] lg:-ml-[4rem] pl-6 lg:pl-16 pr-4 py-2 w-max rounded-r-2xl font-bold">{fsData.fs_description_name}</p>
                            <p className="text-[#E7E9EC] mb-4 text-xl lg:max-w-[550px]">Головний майданчик для тих, хто не просто
                                адаптується, а формує нові правила гри в бізнесі</p>

                            <div className="sm:flex gap-8 mb-4">

                                <div className="mr-5 flex flex-wrap items-center mb-4 sm:mb-0">
                                    <div
                                        className="w-[35px] h-[35px] mr-[15px] rounded-full p-2 bg-[#E7E9EC] flex items-center justify-center">
                                        <IoCalendar className="text-[#003366] text-[30px] "/>
                                    </div>
                                    <div className="w-[calc(100%-50px)] text-[#E7E9EC]">{fsData.fs_date}</div>
                                </div>

                                <div className="flex flex-wrap items-center max-w-[250px] sm:max-w-[400px]">
                                    <div
                                        className="w-[35px] h-[35px] mr-[15px] rounded-full p-2 bg-[#E7E9EC] flex items-center justify-center">
                                        <MdPlace className="text-[#003366] bg-[#E7E9EC] text-[30px] rounded-full"/>
                                    </div>
                                    <div className="w-[calc(100%-50px)] text-[#E7E9EC]">{fsData.fs_place}</div>
                                </div>

                            </div>

                            <div className="relative h-full">
                                <div className="w-full max-w-[95%] lg:max-w-[550px]">
                                    <div className="backdrop-blur bg-[#E7E9EC]/80 p-4 rounded-2xl">
                                        <div className="countdown mb-4">
                                            <MyCountdown/>
                                        </div>
                                        <Form/>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <FirstScreenSpeacers slider_data={fsData.fs_speacers_slider}/>

                    </div>
                    <ScrollAnimation animatePreScroll="true" offset="600"
                                     animateIn="animate__fadeInDown absolute w-2 h-1/2 bg-[#E7E9EC]/75 lg:bg-[#E7E9EC] top-0 right-6 z-30"></ScrollAnimation>
                    <ScrollAnimation animatePreScroll="true" offset="600"
                                     animateIn="animate__fadeInDown absolute w-2 h-2/3 bg-[#E7E9EC] top-0 right-2 z-30"></ScrollAnimation>
                    <ScrollAnimation animatePreScroll="true" offset="600"
                                     animateIn="animate__fadeInDown absolute w-2 h-1/5 bg-[#E7E9EC]/50 lg:bg-[#E7E9EC] lg:bg-[#E7E9EC] top-0 right-10 z-30"></ScrollAnimation>
                    <div className="bg-[#003366]/80 absolute top-0 left-0 w-full h-full z-[15]"></div>
                    <div>
                        <video className="absolute -top-[20%] left-0 w-[140%] h-[140%] z-10 object-cover" loop autoPlay
                               playsInline
                               muted poster={Poster}>
                            <source src={BgVideo} type="video/mp4"/>
                            <source src={BgVideoWebm} type="video/webm"/>
                        </video>
                    </div>
                </div>

                <div className="container mx-auto p-9">
                    <div data-testid="reviews-module-metrics"
                         className="grid w-full grid-cols-2 md:w-auto md:grid-cols-4 [&amp;>*]:border-t-[1px] [&amp;>*]:border-eggplant [&amp;>*]:border-opacity-40 [&amp;>*]:py-10 last:[&amp;>*]:border-r-0 md:[&amp;>*]:border-r-[1px] md:[&amp;>*]:border-t-0 md:[&amp;>*]:px-10 md:[&amp;>*]:py-4">
                        <div className="w-full text-center border-r-2 border-r-gray-500 mb-2">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <p className="copy-h2 text-[42px]">40+</p>
                                <p className="copy-h3-alt">спікерів</p>
                            </ScrollAnimation>
                        </div>
                        <div className="w-full text-center [@media(min-width:767px)]:border-r-2 border-r-gray-500 mb-2">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <p className="copy-h2 text-[42px]">6</p>
                                <p className="copy-h3-alt">панельних дискусій</p>
                            </ScrollAnimation>
                        </div>
                        <div className="w-full text-center border-r-2 border-r-gray-500 mb-2">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <p className="copy-h2 text-[42px]">500+</p>
                                <p className="copy-h3-alt">учасників офлайн</p>
                            </ScrollAnimation>
                        </div>
                        <div className="w-full text-center mb-2">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <p className="copy-h2 text-[42px]">8000+</p>
                                <p className="copy-h3-alt">глядачів онлайн-трансляції</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </section> : ''
    )
}

export default FirstScreenSlider